import { render, staticRenderFns } from "./CertificationsActions.vue?vue&type=template&id=61886229&"
import script from "./CertificationsActions.vue?vue&type=script&lang=js&"
export * from "./CertificationsActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports